<template>
  <div>
    <h4 class="mb-50">Setup</h4>
    <p class="text-muted mb-2">
      SQL queries, mobile request logs, storage health, and database backup.
    </p>
    <b-row>
      <b-col
        v-for="item in tools"
        :key="item.route"
        xl="3"
        md="6"
        class="mb-2"
      >
        <b-card
          class="text-center cursor-pointer h-100 mb-0"
          @click="$router.push({ name: item.route })"
        >
          <div
            class="setup-icon mx-auto mb-1 d-flex align-items-center justify-content-center"
            :class="`bg-light-${item.color}`"
          >
            <feather-icon
              :icon="item.icon"
              size="28"
              :class="`text-${item.color}`"
            />
          </div>
          <h5 class="mb-50">{{ item.title }}</h5>
          <p class="text-muted mb-0">{{ item.description }}</p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'

export default {
  components: { BCard, BCol, BRow },
  data() {
    return {
      tools: [
        {
          title: 'SQL queries',
          description: 'Browse tables and run read-only SQL.',
          icon: 'DatabaseIcon',
          color: 'primary',
          route: 'setup-sql',
        },
        {
          title: 'Mobile requests',
          description: 'Request and response logs from the mobile app.',
          icon: 'SmartphoneIcon',
          color: 'info',
          route: 'setup-request-logs',
        },
        {
          title: 'S3 health',
          description: 'Write, read, and delete a probe file on storage.',
          icon: 'CloudIcon',
          color: 'success',
          route: 'setup-storage-health',
        },
        {
          title: 'Backup',
          description: 'Download a SQL dump of the database.',
          icon: 'DownloadIcon',
          color: 'warning',
          route: 'database-backup',
        },
      ],
    }
  },
}
</script>

<style scoped>
.setup-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
